import React from "react";

// Brands assets
import ceat from "../../../assets/brands/ceat.png";
import ajio from "../../../assets/brands/ajio.png";
import dbs from "../../../assets/brands/dbs.png";
import tata from "../../../assets/brands/tata.png";
import magicbrush from "../../../assets/brands/magicbrush.png";
import gym from "../../../assets/brands/gym.png";
import studio from "../../../assets/brands/studio.png";
import lyzr from "../../../assets/brands/lyzr.png";
import Acciojob from "../../../assets/brands/Acciojob.png";
import purplle from "../../../assets/brands/purplle.png";
import rebalance_logo from "../../../assets/rebalance_logo.png"; // Replace with your image path

// Data for brand logos
const brandLogos = [
  { id: 1, src: ceat, alt: "Ceat Logo" },
  { id: 2, src: ajio, alt: "Ajio Logo" },
  { id: 3, src: dbs, alt: "DBS Logo" },
  { id: 4, src: tata, alt: "Tata Logo" },
  { id: 5, src: magicbrush, alt: "MagicBrush Logo" },
  { id: 6, src: gym, alt: "Gym Logo" },
  { id: 7, src: studio, alt: "Studio Logo" },
  { id: 8, src: lyzr, alt: "Lyzr Logo" },
  { id: 9, src: Acciojob, alt: "Acciojob Logo" },
  { id: 10, src: purplle, alt: "Purplle Logo" },
];

const Brands = () => {
  return (

    <>
    <section className="py-6 mt-12 px-4 md:px-10 text-center" style={{ fontFamily: "Gilroy-Medium" }}>
      <h2 className="text-2xl md:text-3xl font-bold text-black mb-4">
        Trusted by Leading Brands & Empowering Top Creators
      </h2>
      <p className="text-gray-600 max-w-2xl mx-auto mb-6">
        We've worked with some of the best brands and influencers to create impactful campaigns that drive real engagement and measurable success.
      </p>
      <h3 className="text-lg font-semibold mb-8">Our Collaborators-</h3>

      <div className="flex flex-wrap items-center justify-center gap-6">
        {brandLogos.map((brand) => (
          <div key={brand.id} className="w-20 h-12 flex items-center justify-center">
            <img src={brand.src} alt={brand.alt} className="max-h-full max-w-full object-contain" />
          </div>
        ))}
      </div>
    </section>

     <div
            className="py-5  flex flex-row items-center justify-center xs:flex-col items-center "
            style={{ fontFamily: "Gilroy-Medium" }}
          >
            <div>
              {" "}
              <h2 className="text-xxl font-semibold mb-0 text-black ">Supported by-</h2>
            </div>
    
            <div className="flex ml-5 flex-wrap items-center justify-center gap-10">
              <img
                src={rebalance_logo}
                alt="Rebalance Logo 1"
                className="w-36 object-contain"
              />
            </div>
          </div>

          </>
  );
};

export default Brands;
